import authRules from '../authRules';

const viewActivityType = (user) => {
  const { updateActivityCodeInApprovals } = user.securityLevels;
  if (updateActivityCodeInApprovals >= authRules.viewActivityType.updateActivityCodeInApprovals) {
      return true;
  } else {
      return false;
    }
  }


export default viewActivityType;


// WEBPACK FOOTER //
// ./src/AuthLogic/rules/viewActivityType.js